import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=449c3673&scoped=true&"
import script from "./FileSelector.vue?vue&type=script&lang=js&"
export * from "./FileSelector.vue?vue&type=script&lang=js&"
import style0 from "./FileSelector.vue?vue&type=style&index=0&id=449c3673&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449c3673",
  null
  
)

export default component.exports